import type { SVGProps } from 'react'

interface AiSparkleProps extends SVGProps<SVGSVGElement> {
    /** Width/height in px (like lucide's `size`). Omit and use Tailwind h-/w- classes instead. */
    size?: number | string
}

/**
 * Elegant AI mark — a single filled 4-point sparkle.
 *
 * Drop-in replacement for lucide's `Sparkles` for AI-assistant branding. It paints with
 * `currentColor`, so `text-*` classes (taskbar: black/white) and inline `color` styles
 * (Clara tabs: blue) work exactly as before. Pass `size` (number) or Tailwind h-/w- classes.
 */
export function AiSparkle({ size = 24, ...props }: AiSparkleProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            {...props}
        >
            <path d="M12 1.6C12.7 8.5 15.5 11.3 22.4 12 15.5 12.7 12.7 15.5 12 22.4 11.3 15.5 8.5 12.7 1.6 12 8.5 11.3 11.3 8.5 12 1.6Z" />
        </svg>
    )
}
